// This file should be the only place in the UI that colors are defined.
// All files should reference this one for colors.

// Source: Marketing color palettes: https://drive.google.com/drive/folders/12dZACLjHB_ZNWwRs0fGoC1L1-u_dz6s9

// Accelidea green - in the logo
// Darker Accelidea green, used for hover states
// Light gray background color for cards and other surfaces

/////////////////////////////////////////////////////////
// Color palette 1
/////////////////////////////////////////////////////////

export const ACCELIDEA_DARK_BLUE = "#2E5287";
export const ACCELIDEA_BLUE = "#1D73B8";
export const ACCELIDEA_MID_BLUE = "#5BAAEA";
export const ACCELIDEA_LIGHT_BLUE = "#C9E4F9";

export const ACCELIDEA_DARK_PURPLE = "#453459";
export const ACCELIDEA_PURPLE = "#5F5989";
export const ACCELIDEA_MID_PURPLE = "#B6ADE0";
export const ACCELIDEA_LIGHT_PURPLE = "#EDEAF7";

export const ACCELIDEA_DARK_RED = "#843F2F";
document.documentElement.style.setProperty("--ACCELIDEA_DARK_RED", ACCELIDEA_DARK_RED);
export const ACCELIDEA_RED = "#A35C50";
document.documentElement.style.setProperty("--ACCELIDEA_RED", ACCELIDEA_RED);
export const ACCELIDEA_MID_RED = "#FFAC99";
export const ACCELIDEA_LIGHT_RED = "#F3E7E5";

export const ACCELIDEA_DARK_SAND = "#545243";
export const ACCELIDEA_SAND = "#B28947";
export const ACCELIDEA_MID_SAND = "#F0C577";
document.documentElement.style.setProperty("--ACCELIDEA_MID_SAND", ACCELIDEA_MID_SAND);
export const ACCELIDEA_LIGHT_SAND = "#FFF9CE";


/////////////////////////////////////////////////////////
// Color palette 2
/////////////////////////////////////////////////////////

export const ACCELIDEA_BLACK = "#303030";
export const ACCELIDEA_MID_GRAY = "#D9D9D9";
export const ACCELIDEA_LIGHT_GRAY = "#F2F2F2";
export const ACCELIDEA_WHITE = "#FFFFFF";

export const ACCELIDEA_DARK_GRAY = "#626262";
export const ACCELIDEA_DARK_GREEN = "#025131";
document.documentElement.style.setProperty("--ACCELIDEA_DARK_GREEN", ACCELIDEA_DARK_GREEN);
export const ACCELIDEA_MID_GREEN = "#038C5A";
document.documentElement.style.setProperty("--ACCELIDEA_MID_GREEN", ACCELIDEA_MID_GREEN);
export const ACCELIDEA_LIGHT_GREEN = "#C0E2D6";


/////////////////////////////////////////////////////////
// Color palette 3
/////////////////////////////////////////////////////////

// Wrong in the color palette file... export const ACELIDEA_MID_YELLOW = "#5BAAEA";

// This is a version of ACCELIDEA_MID_GREEN with 25% opacity, used for backgrounds and highlights
export const ACCELIDEA_MID_GREEN_25 = "rgba(3, 140, 90, 0.25)";
// This is a version of ACCELIDEA_MID_PURPLE with 25% opacity, used for backgrounds and highlights
export const ACCELIDEA_MID_PURPLE_25 = "rgba(95, 89, 137, 0.25)";
// This is a version of ACCELIDEA_RED with 15% opacity, used for backgrounds and highlights
export const ACCELIDEA_RED_15 = "rgba(163, 92, 80, 0.15)";
// This is a version of ACCELIDEA_BLUE with 25% opacity, used for backgrounds and highlights
export const ACCELIDEA_BLUE_25 = "rgba(29, 115, 184, 0.25)";


/////////////////////////////////////////////////////////
// Tracer Colors - Requirements
export const TRACER_SUBSYSTEM_COLOR = "#C0E2D6";
export const TRACER_SUBSYSTEM_BUTTON_COLOR = "#025131";
export const TRACER_SUBSYSTEM_BUTTON_HOVER_COLOR = "#014021";
export const TRACER_REQUIREMENT_COLOR = "#fff9ce";
export const TRACER_REQUIREMENT_BUTTON_COLOR = "#ffea5c";
export const TRACER_REQUIREMENT_BUTTON_HOVER_COLOR = "#ffde4d";
export const TRACER_SPECIFICATION_COLOR = "#EDEAF7";
export const TRACER_SPECIFICATION_BUTTON_COLOR = "#B6AEE0";
export const TRACER_SPECIFICATION_BUTTON_HOVER_COLOR = "#A79FD3"
export const TRACER_TEST_CASE_COLOR = "#c9e4f9";
export const TRACER_TEST_CASE_BUTTON_COLOR = "#5baaea";
export const TRACER_TEST_CASE_BUTTON_HOVER_COLOR = "#4a98d1";
export const TRACER_TEST_COLOR = "#c9e4f9";
export const TRACER_TEST_BUTTON_COLOR = "#5baaea";
export const TRACER_TEST_BUTTON_HOVER_COLOR = "#4a98d1";
/////////////////////////////////////////////////////////
// Tracer Colors - Risk
export const TRACER_HAZARD_COLOR = "#FFC58F";
export const TRACER_HAZARD_BUTTON_COLOR = "#FF8A33";
export const TRACER_HAZARD_BUTTON_HOVER_COLOR = "#E76900";
export const TRACER_FORESEEABLE_EVENT_COLOR = "#FFF6C2";
export const TRACER_FORESEEABLE_EVENT_BUTTON_COLOR = "#FFDE59";
export const TRACER_FORESEEABLE_EVENT_BUTTON_HOVER_COLOR = "#FFD100";
export const TRACER_HAZARDOUS_SITUATION_COLOR = "#FFEDEB";
export const TRACER_HAZARDOUS_SITUATION_BUTTON_COLOR = "#FFB3A1";
export const TRACER_HAZARDOUS_SITUATION_BUTTON_HOVER_COLOR = "#FF6B54";
export const TRACER_HARM_COLOR = "#FFB3B3";
export const TRACER_HARM_BUTTON_COLOR = "#FF4C4C";
export const TRACER_HARM_BUTTON_HOVER_COLOR = "#E60000";
/////////////////////////////////////////////////////////